import { gql } from "@apollo/client";

export const LABORATORIES = gql`
  query MedicalLaboratory($culture: String!, $status: Status!) {
    medicalLaboratory(where: {localization: {culture: $culture}}, status: $status) {
      displayText
      phoneNumber1
      phoneNumber2
      address
      location {
        latitude
        longitude
      }
      city {
        contentItems {
          __typename
          ... on City {
            contentItemId
            displayText
            name
            country {
              contentItems {
                __typename
                ... on Country {
                  alpha3
                  callingCode
                  flagPosition
                  code {
                    code
                  }
                  name
                }
              }
            }
          }
        }
      }
      travelDestinations {
        contentItems {
          __typename
          ... on Country {
            code {
              code
            }
            flagPosition
            alpha3
            name
          }
        }
      }
    }
  }
`